<script>
    import { createEventDispatcher } from 'svelte';
    import Icon from '../icons/Icon.svelte';

    export let show = false;
    export let table = null;
    export let isClearAll = false;
    export let availableCount = 0;

    const dispatch = createEventDispatcher();

    function handleClose() {
        dispatch('close');
    }

    function handleConfirm() {
        dispatch('confirm');
    }
</script>

{#if show && (isClearAll || table)}
    <div class="modal-overlay" on:click|self={handleClose}>
        <div class="modal-card">
            <div class="modal-header">
                <h3>{isClearAll ? 'Limpar Todas as Mesas Livres?' : `Excluir ${table.label}?`}</h3>
                <button class="close-btn" on:click={handleClose} type="button">
                    <Icon name="x" size={16} />
                </button>
            </div>
            <div class="modal-body">
                {#if isClearAll}
                    <p class="main-msg">
                        Deseja realmente apagar todas as <strong>{availableCount} mesas livres</strong> do salão?
                    </p>
                    <p class="sub-msg">
                        Você poderá criar as mesas do seu restaurante uma a uma com a numeração e capacidade que preferir.
                    </p>
                {:else}
                    <p class="main-msg">
                        Tem certeza que deseja excluir permanentemente a <strong>{table.label} (#{table.table_number})</strong>?
                    </p>
                    <p class="sub-msg">
                        Essa mesa será removida do mapa do salão imediatamente.
                    </p>
                {/if}
            </div>
            <div class="modal-footer">
                <button class="btn-cancel" on:click={handleClose} type="button">Cancelar</button>
                <button class="btn-danger" on:click={handleConfirm} type="button">
                    {isClearAll ? 'Sim, Limpar Mesas' : 'Sim, Excluir Mesa'}
                </button>
            </div>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(15, 23, 42, 0.6);
        backdrop-filter: blur(2px);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
        overflow-y: auto;
        box-sizing: border-box;
        z-index: 9999;
    }

    .modal-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        width: 100%;
        max-width: 480px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        box-sizing: border-box;
        padding: 24px;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
    }

    .modal-header h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 800;
        color: #0F172A;
    }

    .close-btn {
        background: transparent;
        border: none;
        color: #64748B;
        cursor: pointer;
        padding: 4px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background 0.15s, color 0.15s;
    }

    .close-btn:hover {
        background: #F1F5F9;
        color: #0F172A;
    }

    .modal-body {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 24px;
    }

    .main-msg {
        color: #334155;
        font-size: 14px;
        line-height: 1.5;
        margin: 0;
    }

    .sub-msg {
        color: #64748B;
        font-size: 12px;
        margin: 0;
        line-height: 1.4;
    }

    .modal-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;
    }

    .btn-cancel {
        height: 38px;
        padding: 0 16px;
        border: 1px solid #E2E8F0;
        background: #FFFFFF;
        color: #64748B;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.15s, color 0.15s;
    }

    .btn-cancel:hover {
        background: #F8FAFC;
        color: #0F172A;
    }

    .btn-danger {
        height: 38px;
        padding: 0 18px;
        border: none;
        background: #DC2626;
        color: #FFFFFF;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(220, 38, 38, 0.25);
        transition: background 0.15s, transform 0.05s;
    }

    .btn-danger:hover {
        background: #B91C1C;
    }

    .btn-danger:active {
        transform: scale(0.98);
    }
</style>
